/**
Move to system lib?

Status: Done
*/

/**
Copy a string to the user's clipboard.
*/
export default (str: string): void ->
  el := document.createElement 'textarea'
  el.value = str
  el.setAttribute 'readonly', ''
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  document.body.appendChild el

  el.select()
  document.execCommand('copy')

  document.body.removeChild(el)
